module.exports = __webpack_public_path__ + "photo-c0e5aae02eb6444cecf4.svg";